import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../../../Actions/Dashboard';

import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from 'recharts';
import GenericTooltip from './../GenericTooltip';

import Grid from '@material-ui/core/Grid';

import './topStyle.css';

class TopComponent extends Component {
  onClick = (uno) => {
    try {
      const type = this.props.name.split('_')
      this.props.actions.selectFilter({ id: uno.activePayload[0].payload.id, value: uno.activePayload[0].payload.name }, type[type.length - 1])
    } catch (e) { }
  }

  domain = () => {
    if (this.props.data.length === 0)
      return [0, 0];
    let resp = this.props.data.reduce((acum, data) => {
      if (acum.value < data.value)
        return data;
      return acum;
    })
    return [0, (parseInt(resp.value * 1.2) + 1)];
  }
  render() {
    console.log(this.props.data)
    return (
      <Grid container>
        <Grid item xs={12} className="text-center">
          <p style={{ fontWeight: "bold" }}>{'Total: ' + this.props.total}</p>
        </Grid>
        <Grid item xs={12} style={{ textAlign: 'center' }} >
          {
            this.props.data.map((entry, index) => (
              <div className='legend-box-top' key={'div-bars-' + this.props.name + index}><div style={{ backgroundColor: this.props.colors[index % this.props.colors.length] }}></div><p>{entry.name}</p></div>
            ))
          }
        </Grid>
        <Grid item xs={12} className="graphic-margin-top text-center">
          <BarChart width={400} height={250} data={this.props.data}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            style={{ margin: 'auto' }}
            onClick={this.onClick}>
            <XAxis dataKey="name" fontSize={0} interval={0} tick={false} />
            <YAxis fontSize={12} allowDecimals={false} domain={this.domain()} />
            <Tooltip content={
              <GenericTooltip
                data={this.props.data}
                colors={this.props.colors}
              />}
            />
            <Bar dataKey="value" fill="#006290" label={{ position: 'top', fontSize: 14 }}>
              {
                this.props.data.map((entry, index) => (
                  <Cell key={'cell-bars-' + this.props.name + index} fill={this.props.colors[index % this.props.colors.length]} />
                ))
              }
            </Bar>
          </BarChart>
        </Grid>
      </Grid>

    )
  }
}

function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

export default connect(null, mapDispathToProps)(TopComponent);
